


/* App. Setting */
import { InjectionToken } from '@angular/core';

export let APP_CONFIG_OFERTAS = new InjectionToken('app.config');

/* CONSTANTES OFERTAS LABORALES  */
export interface IAppOfertas{
    tipo_constantes: {name};
    estado_0: { number: number, name: string, detail?: string };
    estado_1: { number: number, name: string, detail?: string };
    estado_2: { number: number, name: string, detail?: string };
    estado_3: { number: number, name: string, detail?: string };
    estado_4: { number: number, name: string, detail?: string };
    estado_5: { number: number, name: string, detail?: string };
    estado_6: { number: number, name: string, detail?: string };
    estado_14: { number: number, name: string, detail?: string };
    estado_15: { number: number, name: string, detail?: string };
    estado_16: { number: number, name: string, detail?: string };
    
    selectEstados: { number: number, name: string, detail?: string }[];
    documentacion: { pendiente: string, completo: string };
    nombrePendienteCarga: { detalle: string };
    paisDefault: string;

}

export const AppOfertas: IAppOfertas = {

    tipo_constantes: {name: 'OFERTA-LABORAL'},
    estado_0: {number: 0, name: '1/4-PRESENTADO', detail: 'progreso de su solicitud...'},
    estado_1: {number: 1, name: '1/4-PRESENTADO', detail: 'progreso de su solicitud...'},
    estado_2: {number: 2, name: '2/4-EN REVISION', detail: 'progreso de su solicitud...'},
    estado_3: {number: 3, name: '3/4-APROBADO', detail: 'progreso de su solicitud...'},   
    estado_4: {number: 4, name: '4/4-ENTREGADO', detail: 'progreso de su solicitud...'},
    estado_5: {number: 5, name: 'ANULADO', detail: 'progreso de su solicitud...'},
    estado_6: {number: 6, name: 'EN ESPERA', detail: 'progreso de su solicitud...'},
    estado_14: {number: 14, name: 'Inscripción parcial', detail: 'progreso de su solicitud...'},
    estado_15: {number: 15, name: 'Inscripción completa (DDJJ)', detail: 'progreso de su solicitud...'},
    estado_16: {number: 16, name: 'Inscripción aprobada', detail: 'progreso de su solicitud...'},

    selectEstados: [
        {number: 1, name: '1/4-PRESENTADO', detail: 'progreso de su solicitud...'},
        {number: 2, name: '2/4-EN REVISION', detail: 'progreso de su solicitud...'},
        {number: 3, name: '3/4-APROBADO', detail: 'progreso de su solicitud...'},   
        {number: 4, name: '4/4-ENTREGADO', detail: 'progreso de su solicitud...'},
        {number: 5, name: 'ANULADO', detail: 'progreso de su solicitud...'},
        {number: 6, name: 'EN ESPERA', detail: 'progreso de su solicitud...'},
        {number: 14, name: 'Inscripción parcial', detail: 'progreso de su solicitud...'},
        {number: 15, name: 'Inscripción completa (DDJJ)', detail: 'progreso de su solicitud...'},
        {number: 16, name: 'Inscripción aprobada', detail: 'progreso de su solicitud...'},
    
    ],
    documentacion: { pendiente: 'Pendiente', completo: 'Completo' },  
    nombrePendienteCarga: { detalle: 'carga pendiente' },
    paisDefault: '609bd53ef04ad82d91ca2a2e', // ARGENTINA
    
};

/* CONSTANTES SIGNO MÉDICO */
